<template>
  <div>
    <div class="slid">
      <img
        :src="
          (exhibitor &&
            exhibitor.properties &&
            exhibitor.properties.backgroundImage) ||
            require('../assets/images/slide1.png')
        "
        style="width: 100%; height: auto"
      />
    </div>

    <div class="content">
      <div class="bread">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">{{
            $t("ChinaCycle")
          }}</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/business' }">
            {{ $t("business") }}</el-breadcrumb-item
          >
          <el-breadcrumb-item
            v-if="exhibitor.venue"
            :to="{ path: `/business?venue.id=${exhibitor.venue.id}` }"
          >
            {{
              $i18n.locale == "zh"
                ? exhibitor.venue.number + "馆"
                : exhibitor.venue.number
            }}</el-breadcrumb-item
          >
          <el-breadcrumb-item>
            <div class="text-ellipsis" style="max-width: 800px;">
              {{ $i18n.locale == "zh" ? exhibitor.name : exhibitor.nameEn }}
            </div>
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="article">
        <div class="business-item" style="width: 490px">
          <div
            class="row"
            style="align-items: flex-start; justify-content: space-between"
          >
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: center;
                width: 200px;
                height: 200px;
              "
            >
              <img
                :src="
                  !!exhibitor.properties && !!exhibitor.properties.logo
                    ? exhibitor.properties.logo
                    : require('../assets/images/icon_2.png')
                "
                style="max-width: 100%; max-height: 100%"
                onerror="onImg()"
              />
            </div>

            <div class="row business-item-left">
              <div
                v-if="exhibitor.collected"
                class="row business-item-leftbtn1"
                style="background: #619a37; color: #ffffff"
                @click.stop="
                  handleCollectClick('EXHIBITOR', exhibitor.id, true)
                "
              >
                <img
                  src="../assets/images/collect.png"
                  width="14px"
                  height="12px"
                />
                <p>
                  {{ $t("Favorite") }}
                </p>
              </div>
              <div
                class="row business-item-leftbtn1"
                v-else
                @click.stop="
                  handleCollectClick('EXHIBITOR', exhibitor.id, false)
                "
              >
                <img
                  src="../assets/images/collect.png"
                  width="14px"
                  height="12px"
                />
                <p>
                  {{ $t("Favorite") }}
                </p>
              </div>
              <div
                v-if="exhibitor.liked"
                class="business-item-leftbtn2"
                style="background: #619a37"
                @click.stop="handleLikeClick('EXHIBITOR', exhibitor.id, true)"
              >
                <img
                  src="../assets/images/great.png"
                  width="14px"
                  height="12px"
                />
              </div>
              <div
                v-else
                class="business-item-leftbtn2"
                @click.stop="handleLikeClick('EXHIBITOR', exhibitor.id, false)"
              >
                <img
                  src="../assets/images/great.png"
                  width="14px"
                  height="12px"
                />
              </div>
            </div>
          </div>
          <div class="business-item-detail">
            <p>
              {{ $i18n.locale == "zh" ? exhibitor.name : exhibitor.nameEn }}
            </p>
            <div class="line"></div>
            <!--<p>{{ $t("Company Details2") }}</p>-->
            <!--<p>-->
            <!--  {{-->
            <!--    $i18n.locale == "zh"-->
            <!--      ? exhibitor.description-->
            <!--      : exhibitor.descriptionEn-->
            <!--  }}-->
            <!--</p>-->
            <!-- <p
              v-if="
                $i18n.locale == 'zh'
                  ? !!exhibitor.description
                  : !!exhibitor.descriptionEn
              "
            >
              {{ $t("All Information") }}
            </p> -->
            <!-- <p></p> -->
            <p class="zifu" style="margin-bottom: 6px; margin-right: 30px;">
              {{ $t("Business Content") }}：{{
                $i18n.locale == "zh"
                  ? exhibitor.businessScope
                  : exhibitor.businessScopeEn
              }}
            </p>
            <p style="margin-bottom: 130px; margin-right: 30px;">
              {{ $t("Company Address") }}：
              {{
                $i18n.locale == "zh" ? exhibitor.address : exhibitor.addressEn
              }}
            </p>
          </div>
          <div class="row business-item-btn">
            <p class="collect" @click.stop="handleAppointmentClick(exhibitor)">
              {{ $t("Send Invitation") }}
            </p>
            <p v-if="false" class="great" @click.stop="handleContactClick(exhibitor)">
              {{ $t("Send Massage") }}
            </p>
          </div>
        </div>
        <el-carousel trigger="click" class="home_banner" :autoplay="false">
          <el-carousel-item
            v-for="(item, idx) in !!exhibitor.properties &&
            !!exhibitor.properties.albums
              ? exhibitor.properties.albums
              : [require('../assets/images/icon_1.png')]"
            :key="idx"
            onerror="onImg()"
          >
            <div
              style="width: 96%; height: 100%; margin: auto"
              class="row-center"
            >
              <img
                v-if="!/\.mp4$/.test(item)"
                style="max-width: 100%; max-height: 100%"
                :src="item"
                alt
              />
              <video v-else style="max-width: 100%" :src="item" alt controls />
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>

      <div class="article1">
        <el-tabs
          tab-position="left"
          style="min-height: 302px"
          type="border-card"
        >
          <el-tab-pane :label="$t('Company Details2')">
            <div
              v-if="$i18n.locale == 'zh' && exhibitor.description"
              v-html="exhibitor.description"
            ></div>
            <div
              v-if="$i18n.locale == 'en' && exhibitor.descriptionEn"
              v-html="exhibitor.descriptionEn"
            ></div>
            <!-- <div
              v-if="exhibitor.descriptionEn && exhibitor.description"
              v-html="
                $i18n.locale == 'en'
                  ? exhibitor.descriptionEn
                  : exhibitor.description
              "
            ></div>
            <div v-else>/</div> -->
          </el-tab-pane>
          <el-tab-pane :label="$t('Products List')">
            <template v-for="(exhibit, idx) of exhibitNameList">
              <div
                :key="idx"
                style="width: 50%; display: inline-block; line-height: 40px; color: #619a37; cursor: pointer"
                @click="toExhibitPage(idx, exhibit.id)"
                class="text-ellipsis"
              >
                {{ $i18n.locale == "zh" ? exhibit.name : exhibit.nameEn }}
                <!--<router-link :to="`/exhibit/${exhibit.id}`">-->
                <!--  {{ $i18n.locale == "zh" ? exhibit.name : exhibit.nameEn }}-->
                <!--</router-link>-->
              </div>
            </template>
          </el-tab-pane>
          <el-tab-pane :label="$t('Find us in Exhibition')" class="pictures">
            <!-- {{exhibitor.properties.exhibitionAlbum}} -->
            <template
              v-if="
                exhibitor && exhibitor.properties && exhibitor.properties.albums
              "
            >
              <div
                style="display: flex; align-items: center; justify-content: flex-start; flex-wrap: wrap; gap: 20px"
              >
                <div
                  class="image-wrapper"
                  v-for="item in exhibitor.properties.albums"
                  :key="item"
                  style="width: 25%; padding: 10px; box-sizing: border-box"
                >
                  <img :src="item" alt="" style="width: 100%;" />
                </div>
              </div>
            </template>
          </el-tab-pane>
          <el-tab-pane :label="$t('Contact Information')">
            <p style="margin-bottom: 10px;">
              {{ $t("Contact") }}：{{
                $i18n.locale == "zh" ? exhibitor.contact : exhibitor.contactEn
              }}
            </p>
            <p style="margin-bottom: 10px;">
              {{ $t("Contact Title") }}：{{
                $i18n.locale == "zh"
                  ? exhibitor.contactDuty
                  : exhibitor.contactDutyEn
              }}
            </p>
            <p style="margin-bottom: 10px;">
              {{ $t("Contact Phone") }}：{{
                $i18n.locale == "zh"
                  ? exhibitor.contactNumber
                  : exhibitor.contactNumber
              }}
            </p>
            <p style="margin-bottom: 10px;">
              {{ $t("Contact E-mail") }}：{{
                $i18n.locale == "zh"
                  ? exhibitor.contactEmail
                  : exhibitor.contactEmail
              }}
            </p>
            <p style="margin-bottom: 10px;">
              {{ $t("Company Website") }}：
              <span style="cursor: pointer" @click="toSite">{{
                exhibitor.website || ""
              }}</span>
            </p>
            <p style="align-items: flex-start; display: flex">
              {{ $t("Company QRCode") }}：<img
                style="max-width: 300px"
                :src="exhibitor.properties.qrcode"
                v-if="exhibitor.properties && exhibitor.properties.qrcode"
              />
            </p>
          </el-tab-pane>
        </el-tabs>
      </div>

      <div class="intro-wrapper">
        <div class="row-between">
          <div class="intro-title">{{ $t("Products List") }}</div>
          <div class="product-line"></div>
          <div class="intro-all" @click="goall">{{ $t("Products") }}</div>
        </div>
      </div>

      <!-- <div> -->

      <!-- </div> -->

      <div class="article2">
        <div
          class="article-item column-between"
          v-for="(item, idx) in exhibits"
          :key="idx"
          @click="handleExhibitClick(item)"
        >
          <div class="article-item-img">
            <img
              style="height: 170px"
              v-if="item && item.properties && item.properties.albums"
              :src="item.properties.albums[0]"
            />
            <img style="height: 170px" v-else src="@/assets/images/bike.png" />
          </div>
          <div class="column" style="width: 100%; text-align: center">
            <p class="article-item-title">
              {{ $i18n.locale == "zh" ? item.name : item.nameEn }}
            </p>
            <div class="article-item-line"></div>
            <p class="article-item-type">
              <!--{{-->
              <!--  item.categories-->
              <!--    .map((c) =>-->
              <!--      $i18n.locale == "zh" ? c.categoryName : c.categoryNameEn-->
              <!--    )-->
              <!--    .join(" | ")-->
              <!--}}-->
              {{
                $i18n.locale == "zh" ? item.categoryName : item.categoryNameEn
              }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <Dialoglist
      v-if="dialogFormVisible"
      :key="dialogFormVisible"
      :exhibitid="exhibitid"
      :dialogtype="'contactbusiness'"
      :dialogFormVisible="dialogFormVisible"
      @handleCloseDialog="is => (dialogFormVisible = is)"
    />
    <Dialoglist
      v-if="reservedialogFormVisible"
      :key="reservedialogFormVisible"
      :exhibitid="exhibitid"
      :dialogtype="'reserve'"
      :dialogFormVisible="reservedialogFormVisible"
      @handleCloseDialog="is => (reservedialogFormVisible = is)"
    />

    <ShareButton url="/web/share-image/company" :params="shareParams" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import { EventBus } from "../EventBus";

import ExhibitorService from "../services/exhibitor";
import ExhibitService from "../services/exhibit";

import Dialoglist from "@/components/dialoglist";
import ShareButton from "@/components/share-button";
import { getExhibitsPageList } from "../http/api";

import { objectToQueryString } from "@/libs/utils";

export default {
  components: { Dialoglist, ShareButton },
  data() {
    return {
      exhibitor: {},
      exhibits: [],
      exhibitid: "",
      dialogFormVisible: false,
      reservedialogFormVisible: false,
      shareParams: {},
      exhibitNameList: []
    };
  },
  computed: {
    ...mapGetters({
      hasAuthentication: "hasAuthentication",
      hasCollected: "hasCollected",
      hasLiked: "hasLiked"
    })
  },
  watch: {
    "$i18n.locale"(val) {
      this.shareParams = Object.assign({}, this.shareParams, {
        fileName:
          this.$i18n.locale == "zh"
            ? this.exhibitor.name
            : this.exhibitor.nameEn,
        // companyBannerUrl: this.exhibitor.properties.topImage,
        companyLogo: Array.isArray(this.exhibitor.properties.logo)
          ? this.exhibitor.properties.logo[0]
          : this.exhibitor.properties.logo,
        companyName:
          this.$i18n.locale == "zh"
            ? this.exhibitor.name
            : this.exhibitor.nameEn,
        companyUrl: `${process.env.VUE_APP_H5_BASE_URL}/index/exhibitorDetail/${this.exhibitor.id}`,
        companyBannerUrl: Array.isArray(this.exhibitor.properties.topImage)
          ? this.exhibitor.properties.topImage[0]
          : this.exhibitor.properties.topImage,
        homeUrl: `${process.env.VUE_APP_H5_BASE_URL}`,
        page: "pages/exhibitor/detail",
        scene: objectToQueryString({
          id: this.exhibitor.id,
          lang: this.$i18n.locale == "zh" ? "zh" : "en"
        }),
        boothNumber:
          this.exhibitor.boothNumber == null ||
          this.exhibitor.boothNumber == undefined ||
          this.exhibitor.boothNumber == ""
            ? ""
            : this.exhibitor.boothNumber
      });
    }
  },
  methods: {
    ...mapActions({
      addCollected: "addCollected",
      deleteCollected: "deleteCollected",
      addLiked: "addLiked",
      deleteLiked: "deleteLiked"
    }),
    toSite() {
      window.open(this.exhibitor.website);
    },
    handleExhibitClick(exhibit) {
      this.$router.push(`/exhibit/${exhibit.id}?from=exhibitor`);
    },
    goall() {
      this.$router.push({
        name: "productlist",
        query: {
          id: this.exhibitor.id
        }
      });
    },
    // -------------------------------------------------------------------------------------------------
    // 联系点击事件
    handleContactClick(exhibit) {
      if (!this.hasAuthentication()) {
        this.$router.push("/login");
        return;
      }

      this.exhibitid = exhibit.id;
      this.dialogFormVisible = true;
    },
    // 预约点击事件
    handleAppointmentClick(exhibit) {
      if (!this.hasAuthentication()) {
        this.$router.push("/login");
        return;
      }

      this.exhibitid = exhibit.id;
      this.reservedialogFormVisible = true;
    },

    async handleCollectClick(type, id, status) {
      if (status) {
        // 已经收藏
        await this.deleteCollected({
          type: type,
          id: id
        });
      } else {
        //收藏
        await this.addCollected({
          type: type,
          id: id
        });
      }
    },
    async handleLikeClick(type, id, status) {
      if (status) {
        // 已经收藏
        await this.deleteLiked({
          type: type,
          id: id
        });
      } else {
        //收藏
        await this.addLiked({
          type: type,
          id: id
        });
      }
    },
    async getExhibitor(exhibitor) {
      const result = await ExhibitorService.getEntityDetail(exhibitor);
      result.description =
        result.description &&
        result.description.replace(/<img.*?>/gi, match => {
          console.log(match);
          // 判断该 img 标签是否已经包含了 max-width 样式
          if (match.indexOf("max-width:") === -1) {
            // 如果没有，就在 img 标签里添加 max-width 样式
            return match.replace(/<img/, '<img style="max-width:100%;"');
          } else {
            // 如果已有 max-width 样式，就不做修改
            return match;
          }
        });
      result.descriptionEn =
        result.descriptionEn &&
        result.descriptionEn.replace(/<img.*?>/gi, match => {
          console.log(match);
          // 判断该 img 标签是否已经包含了 max-width 样式
          if (match.indexOf("max-width:") === -1) {
            // 如果没有，就在 img 标签里添加 max-width 样式
            return match.replace(/<img/, '<img style="max-width:100%;"');
          } else {
            // 如果已有 max-width 样式，就不做修改
            return match;
          }
        });
      this.exhibitor = result;

      this.exhibitor.liked = this.hasLiked("EXHIBITOR", this.exhibitor.id);
      this.exhibitor.collected = this.hasCollected(
        "EXHIBITOR",
        this.exhibitor.id
      );
      this.shareParams = Object.assign({}, this.shareParams, {
        fileName: this.$i18n.locale == "zh" ? result.name : result.nameEn,
        // companyBannerUrl: result.properties.topImage,
        companyLogo: Array.isArray(result.properties.logo)
          ? result.properties.logo[0]
          : result.properties.logo,
        companyName: this.$i18n.locale == "zh" ? result.name : result.nameEn,
        companyUrl: `${process.env.VUE_APP_H5_BASE_URL}/index/exhibitorDetail/${result.id}`,
        companyBannerUrl: Array.isArray(result.properties.topImage)
          ? result.properties.topImage[0]
          : result.properties.topImage,
        homeUrl: `${process.env.VUE_APP_H5_BASE_URL}`,
        page: "pages/exhibitor/detail",
        scene: objectToQueryString({
          id: this.exhibitor.id,
          lang: this.$i18n.locale == "zh" ? "zh" : "en"
        }),
        boothNumber:
          result.boothNumber == null ||
          result.boothNumber == undefined ||
          result.boothNumber == ""
            ? ""
            : result.boothNumber
      });
    },
    async getExhibits(exhibit, sortable) {
      const result = await getExhibitsPageList(exhibit, {
        ...sortable,
        isUp: true
      });
      const list = result.content;
      this.exhibits = [...list].slice(0, 4);
      this.exhibitNameList = [...list].splice(0, 11);
      if (list.length >= 12) {
        this.exhibitNameList.push({
          name: "查看全部产品",
          nameEn: "ALL"
        });
      }

      this.shareParams = Object.assign({}, this.shareParams, {
        productList: list.map(item => ({
          productName: this.$i18n.locale == "zh" ? item.name : item.nameEn,
          productUrl:
            item.properties &&
            item.properties.albums &&
            item.properties.albums[0]
        }))
      });
    },
    // async getExhibitPage(exhibit, pageable) {
    //   const result = await ExhibitService.getEntityPage(exhibit, pageable);

    //   this.exhibits = result.content;
    // },
    toExhibitPage(index, exhibitId) {
      if (index === 11) {
        this.goall();
      } else {
        this.$router.push(`/exhibit/${exhibitId}`);
      }
    }
  },
  async mounted() {
    this.exhibitor = { id: this.$route.query.id };
    this.getExhibitor(this.exhibitor);
    this.getExhibits(
      {
        exhibitorId: this.exhibitor.id,
        enabled: true
        // approveResult: "APPROVED",
        // approved: true,
      },
      {
        page: 0,
        size: 12,
        sort: "order_number desc"
        // sort: ["orderNumber,desc","createTime,DESC" ],
        // sort: ,
      }
    );

    EventBus.$on("setLiked", () => {
      this.exhibitor = {
        ...this.exhibitor,
        liked: this.hasLiked("EXHIBITOR", this.exhibitor.id)
      };
    });

    EventBus.$on("setCollected", () => {
      this.exhibitor = {
        ...this.exhibitor,
        collected: this.hasCollected("EXHIBITOR", this.exhibitor.id)
      };
    });
  }
};
</script>
<style lang="less" scoped>
.pictures {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.content {
  max-width: 100%;
  box-sizing: border-box;
  //margin: 80px auto 0;
  background: #eaeaea;
}
/deep/ .home_banner .el-carousel__container {
  width: 678px !important;
  height: 513px !important;
}
.article {
  padding: 20px;
  box-sizing: border-box;
  width: 1200px;
  margin: 0 auto;
  background: #ffffff;
  display: flex;
  flex-direction: row;
}

.article1 {
  max-width: 1200px;
  margin: 0 auto;
  background: #ffffff;
  margin-top: 40px;
}

.article2 {
  padding: 0px;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  // justify-content: space-between;
  padding-bottom: 30px;
  //   background: #FFFFFF;
}
.article-item:nth-child(4n) {
  margin-right: unset;
}
.article-item {
  width: 277px;
  height: 372px;
  background: #ffffff;
  border: 1px solid #dddddd;
  cursor: pointer;
  margin-right: 30px;
  overflow: hidden;
  &:hover {
    .article-item-img {
      transform: scale(1.1);
    }
  }
  .article-item-img {
    height: 260px;
    width: 275px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
  .article-item-title {
    font-size: 14px;
    font-family: FZLanTingHeiS-DB1-GBK;
    font-weight: 400;
    color: #444444;
    width: 100%;
    padding: 0 10%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: center;
  }
  .article-item-title:hover {
    color: #619a37;
  }
  .article-item-line {
    width: 100%;
    height: 1px;
    background: #dddddd;
    margin-top: 18px;
  }
  .article-item-type {
    font-size: 14px;
    font-family: FZLanTingHeiS-DB1-GBK;
    font-weight: 400;
    color: #999999;
    padding: 15px;
    &:hover {
      background-color: #619a37;
      color: #ffffff;
    }
  }
}
.topic {
  // text-align:center
}
.directions {
  width: 1088pxx;
  height: 26px;
  font-size: 12px;
  font-family: FZLanTingHei-DB-GBK;
  font-weight: 400;
  color: #999999;
  line-height: 20px;
}
.great .collect {
  float: right;
  cursor: pointer;
}
// .button {
//     margin:80 auto;
// }
.pn {
  height: 14px;
  font-size: 14px;
  font-family: FZLanTingHei-DB-GBK;
}
.intro-wrapper {
  width: 1200px;
  margin: 0 auto;
  border-bottom: 1px solid #dddddd;
  padding: 38px 0 17px 0;
  margin-bottom: 25px;
  position: relative;
  .product-line {
    width: 119px;
    height: 2px;
    background: #619a37;
    position: absolute;
    bottom: 0;
    left: 0;
  }
  .intro-title {
    font-size: 20px;
    font-family: FZLanTingHeiS-DB1-GBK;
    font-weight: 400;
    color: #444444;
  }
  .intro-all {
    font-size: 14px;
    font-family: FZLanTingHeiS-DB1-GBK;
    font-weight: 400;
    color: #444444;
    background: #ffffff;
    border: 1px solid #dddddd;
    padding: 8px 24px;
    cursor: pointer;
  }
}
.bread {
  padding: 20px 0;
  width: 1200px;
  margin: 0 auto;
}
.business-item-leftbtn1 {
  background: #999999;
  font-size: 14px;
  font-family: FZLanTingHeiS-DB1-GBK;
  font-weight: 400;
  color: #ffffff;
  padding: 16px;
  cursor: pointer;
  img {
  }
  p {
    line-height: 12px;
    margin-left: 6px;
  }
}
.business-item {
  display: flex;
  flex-direction: column;
  align-self: center;
  // justify-content: space-between;
}
.business-item-leftbtn2 {
  background: #999999;
  padding: 11px 16px;
  margin-left: 9px;
  margin-right: 30px;
  cursor: pointer;
}
.business-item-detail {
  & p:first-child {
    font-size: 28px;
    font-family: FZLanTingHeiS-DB1-GBK;
    font-weight: 400;
    color: #444444;
    margin-top: 20px;
  }
  .line {
    width: calc(100% - 30px);
    height: 1px;
    background: #dddddd;
    margin: 10px 0 25px;
  }
  & p:nth-child(3) {
    // font-size: 18px;
    font-family: FZLanTingHei-R-GBK;
    font-weight: 400;
    color: #666666;
  }
  & p:nth-child(4) {
    // font-size: 14px;
    font-family: FZLanTingHei-R-GBK;
    font-weight: 400;
    color: #666666;
    // margin-top: 15px;
  }
  & p:nth-child(5) {
    font-size: 14px;
    font-family: FZLanTingHei-R-GBK;
    font-weight: 400;
    color: #619a37;
  }
  & p:nth-child(6) {
    font-size: 14px;
    font-family: FZLanTingHeiS-DB1-GBK;
    font-weight: 400;
    color: #666666;
    margin-top: 30px;
    margin-bottom: 14px;
  }
  & p:nth-child(7) {
    font-size: 14px;
    font-family: FZLanTingHeiS-DB1-GBK;
    font-weight: 400;
    color: #666666;
    margin-bottom: 30px;
  }
}
.collect {
  width: 173px;
  height: 46px;
  background: #619a37;
  margin-right: 10px;
  color: #ffffff;
  line-height: 46px;
  text-align: center;
  cursor: pointer;
}
.great {
  width: 173px;
  height: 46px;
  background: #ffffff;
  border: 1px solid #dddddd;
  color: #999999;
  line-height: 46px;
  text-align: center;
  cursor: pointer;
}
// .zifu {
//   overflow: hidden;
//   text-overflow: ellipsis;
//   white-space: nowrap;
//   width: 300px;
// }

/deep/ .el-breadcrumb {
  .el-breadcrumb__item:last-child {
    span {
      font-weight: 700;
      text-decoration: none;
      // color: #303133;
    }
  }
}

/deep/.article1 .el-tabs__header {
  height: 300px !important;
}

/deep/ .el-tabs__item {
  // font-weight: 700;
  font-family: FZLanTingHeiS-DB1-GBK;
}

/deep/ .el-tabs--border-card > .el-tabs__header .el-tabs__item:hover {
  background-color: #619a37 !important;
  color: #ffffff !important;
}
</style>



// WEBPACK FOOTER //
// src/view/companyIntroduction.vue